<template>
  <b-row>
    <b-col sm="12">
      <b-card>

        <b-row class="pt-sm-2">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>등록일</strong></b-col>
          <b-col sm="3">
            <form>
              <date-picker v-model="fullDateTmp"
                           type="date"
                           style="width: 100%;"
                           range
                           placeholder="조회기간 선택"
                           :lang="datepickerLang"
                           @change="handleDateRangeChange"/>
            </form>
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>


        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>권한등급</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="auth_type" v-model="queryParams.authority" :options="manager_auth_option" name="sales_type"/>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>권한상태</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="status_type" v-model="queryParams.status" :options="manager_status_option" name="order_type"/>
          </b-col>
        </b-row>


        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="1">
            <b-form-select v-model="queryParams.search_type">
              <option value="all">전체</option>
              <option value="user_id">아이디</option>
              <option value="user_name">이름</option>
            </b-form-select>
          </b-col>
          <b-col sm="7">
            <form>
              <b-form-input v-model="queryParams.keyword" placeholder=""
                            v-on:keyup="$event.keyCode === 13 ? findManager() : ''"/>
            </form>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button variant="primary" style="width: 100%;" v-on:click="findManager()">검색</b-button>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import { EventBus } from "../../../event-bus";

export default {
  name: 'ManagerSearch',
  props: {
    queryParams: {
      type: Object
    },
    fullDate: {
      type: Array,
    },
  },
  components: {
    DatePicker
  },
  data () {
    return {
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      manager_auth_option: [
        {text: '전체', value: 'all'},
        {text: '슈퍼관리자', value: 'MNGR_ATHRT_1'},
        {text: '운영관리자', value: 'MNGR_ATHRT_2'},
        {text: '콘텐츠관리자', value: 'MNGR_ATHRT_3'},
      ],
      manager_status_option: [
        {text: '전체', value: 'all'},
        {text: '허용', value: 'MNGR_STATUS_1'},
        {text: '만료', value: 'MNGR_STATUS_2'},
      ],
      view_type_option: [
        {text: '조회순', value: 'VIEW'},
        {text: '추천순', value: 'RECOMMAND'},
        {text: '다운로드순', value: 'DOWNLOAD'},
        {text: '후속연구요청순', value: 'RESEARCH'},
      ],
      active_yn_options: [{text: '전체', value: 'all'}, {text: '활성', value: 'Y'}, {text: '비활성', value: 'N'}],
      fullDateTmp: [],
    }
  },
  mounted() {
  },
  methods: {
    findManager() {
      this.queryParams.keyword = this.queryParams.keyword.replace(/\s/g, '');
      EventBus.$emit('callFindManager');
    },

    handleDateRangeChange() {
      this.$parent.fullDate = this.fullDateTmp;
      console.log('handleDateRangeChange >>>>', this.$parent.fullDate);
    },

    // 날짜 정의
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/common/manager/component/ManagerSearch.vue